import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgPencilWrite = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M12.3644 12.8584L9.35352 13.2892L9.78341 10.2775L17.5263 2.53454C17.8686 2.19228 18.3328 2 18.8168 2C19.3009 2 19.7651 2.19228 20.1073 2.53454C20.4496 2.8768 20.6419 3.341 20.6419 3.82503C20.6419 4.30905 20.4496 4.77326 20.1073 5.11552L12.3644 12.8584Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.6001 12.9509V19.0343C17.6001 19.357 17.4719 19.6665 17.2438 19.8946C17.0156 20.1228 16.7061 20.251 16.3834 20.251H4.21668C3.89399 20.251 3.58453 20.1228 3.35636 19.8946C3.12819 19.6665 3 19.357 3 19.0343V6.86756C3 6.54487 3.12819 6.23541 3.35636 6.00724C3.58453 5.77906 3.89399 5.65088 4.21668 5.65088H10.3001"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgPencilWrite.displayName = 'SvgPencilWrite';
export default SvgPencilWrite;
